import VueRouter from 'vue-router';
import routes from './routes';
import store from '../Store/index';

const router = new VueRouter({
  mode: 'history',
  base: process.env.baseUrl,
  routes
});

console.log(process.env.baseUrl, 'process.env.baseUrl');
router.beforeEach((to, from, next) => {
  const parentSlug = to.params.slug;

  if (to.path.startsWith('/centers/') && parentSlug) {
    to.meta.part = parentSlug;
  }

  // Force a password change (first login or expired password, m134 p.3)
  // before any authenticated page — cannot be bypassed by navigation.
  const user = store.state.auth.user;
  const mustChangePassword =
    user && (user.is_first_login || user.password_expired);
  if (mustChangePassword && to.name !== 'FirstChangePassword') {
    next({ name: 'FirstChangePassword' });
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (
      store.state.auth.authenticated ||
      to.name === 'OpenPageLessonGroupEdit' ||
      to.name === 'OpenPageLessonGroupEdit'
    ) {
      next();
      return;
    }
    // Password accepted, code not entered yet (e.g. a reload while on
    // the code screen): the code screen, not the login page.
    if (store.state.auth.pendingExpiresIn > 0 && to.name !== 'Confirm') {
      next({ name: 'Confirm', query: { next: to.fullPath } });
      return;
    }
    next({
      path: '/sign-in',
      query: {
        next: to.fullPath
      }
    });
  } else {
    if (
      store.state.auth.authenticated &&
      to.name !== 'EditLessonPage' &&
      to.name !== 'OpenPageLessonGroupEdit'
    ) {
      next('/');
      return;
    }
    next();
  }
});

router.afterEach((to, from) => {});

router.beforeResolve((to, from, next) => {
  next();
});
export default router;
